<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper">
        <q-chips-input v-model="inputValue"
                       :name="path"
                       :float-label="label | capitalize"
                       :color="color"
                       :disable="form.busy || disable"
                       :autofocus="autofocus"
                       :after="[{
                              icon: 'arrow_drop_down',
                              handler () {
                                showTable = true
                              }
                            }]"
                       @input="onInput"></q-chips-input>
        <div>
            <q-popover v-model="showTable">
                Teste
            </q-popover>
        </div>
    </v-field>
</template>

<script>
    import mixins from './mixins'
    import {
        QChipsInput,
        QTable,
        QTr,
        QTd,
        QPopover
    } from 'quasar-framework'

    export default {
        name: 'VHasMany',

        mixins,

        props: {},

        components: {
            QPopover,
            QChipsInput,
            QTable,
            QTr,
            QTd,
            QPopover
        },

        data() {
            return {
                showTable: false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VHasMany.vue